import classNames from "classnames";
import PageContainer from "modules/components/PageContainer";
import Skeleton from "react-loading-skeleton";
import { memo } from "react";
import styles from "./styles.module.scss";

function MakeModelPagePlaceHolder() {
  return (
    <PageContainer>

      <>

        <div className="hidden-xs" style={{ paddingTop: "calc(0.5 * var(--safari-root-font, 10px))", position: "relative" }}>

          <div
            className={classNames(styles.flex_display, "row row-5-padding flex-display row-eq-height")}
          >

            <div className="col-sm-4 col-md-3">

              <Skeleton count={3} />

              <Skeleton height={150} />
            </div>

            <div className="col-sm-8 col-md-9 p-b-30" style={{ paddingRight: 0 }}>

              <Skeleton height={210} />
            </div>
          </div>
        </div>

        <div className="visible-xs">

          <Skeleton height={30} count={1} />

          <Skeleton height={100} count={1} />

          <Skeleton height={30} count={1} />
        </div>

        <Skeleton height={200} count={6} />
      </>
    </PageContainer>
  );
}

export default memo(MakeModelPagePlaceHolder);
